import React from 'react';
import { Redirect } from 'react-router-dom';
import {notify} from 'react-notify-toast';
import firebase from 'firebase';
import Display from '../helpers/display';
import Generate from '../helpers/generate';
import GoogleAnalytics from 'react-ga';
import uuid from 'uuid/v4';

class ProfileCreate extends React.Component {

	constructor(props) {
		super(props);


		this.state = {
			name: '',
			redirect: false
		}
		this.closeCallback = this.closeCallback.bind(this);
		this.handleInputChange = this.handleInputChange.bind(this);
		this.handleSubmit = this.handleSubmit.bind(this);
	}

	componentDidMount() {
		// console.log('ProfileCreate',this.props);
		this.updateState(this.props);
	}

	componentDidUpdate(newProps) {
		if (newProps !== this.props) {
			this.updateState(newProps);
		}
	}

	updateState(props) {

	}

	closeCallback() {
		this.props.callback();
	}

	handleInputChange(event) {
		const value = event.target.value;
		const name = event.target.name;
		this.setState({[name]: value});
	}

	handleSubmit(event) {
		event.preventDefault();

		let user = {
			displayName: this.state.name,
			email: this.state.email
		}

		Generate.profile(this.props.gameId, user, false)
		.then(response => {
			GoogleAnalytics.event({
				category: 'Interaction',
				action: 'ManualProfile',
				label: this.props.gameId,
				nonInteraction: false
			});
			this.setState({ redirect: response.id });
			this.props.callback('close');
			notify.show("Profile Created", "success")

		})
		.catch(error => {
			console.warn('profile creation error', error)
			notify.show("Error Joining Game", "error")
		})
	}

	render() {

		if (this.state.redirect) {
			return <Redirect to={`/game/${this.props.gameId}/profile/${this.state.redirect}`}/>;
		}

		return <aside className="overlay">

			{/* { this.props.type === 'send' && this.renderSendMoney()} */}

			<form onSubmit={this.handleSubmit}>
				<h4>Create a Profile</h4>
				{/* <h2>{this.props.profiles[this.props.to].name}</h2>
				<h3>${this.state.toWallet}
					{this.props.type === 'educate' && ` - ${Display.educationName(this.props.profiles[this.props.to].education)}`}</h3> */}


				<div className="field">
					<label>Full Name</label>
					<input name="name" type="text" placeholder="Name" onChange={this.handleInputChange} />
				</div>

				<div className="field">
					<label>Email Address</label>
					<input name="email" type="email" placeholder="name@email.com" onChange={this.handleInputChange} />
				</div>

				<button type="submit" className="button -huge -primary -icon -send">Create</button>

			</form>

			<a className="close" onClick={this.closeCallback}>
				<span>Cancel</span>X
			</a>

		</aside>
	}
}

export default ProfileCreate



// WEBPACK FOOTER //
// ./src/components/game/profile.create.js